import {
  bindCallback,
  bindNodeCallback,
  defer,
  EMPTY,
  fromEvent,
  fromEventPattern,
  from,
  generate,
  iif,
  interval,
  of,
  range,
  throwError,
  timer
} from "rxjs";
import { delayWhen } from "rxjs/operators";

export const creationExamples = {
  // Creates the Observable lazily, that is, only when it is subscribed.
  defer: {
    label: "defer(() => of(10, 20, 30))",
    inputs: [],
    apply: function (inputs, scheduler) {
      return defer(() =>
        of(10, 20, 30).pipe(delayWhen((x) => timer(x, scheduler)))
      );
    }
  },

  // Just emits 'complete', and nothing else.
  EMPTY: {
    label: "EMPTY",
    inputs: [],
    apply: function (inputs, scheduler) {
      return EMPTY;
    }
  },

  from: {
    label: "from([10, 20, 30])",
    inputs: [],
    apply: function (inputs, scheduler) {
      return from([10, 20, 30]).pipe(delayWhen((x) => timer(x, scheduler)));
    }
  },

  fromEvent: {
    label: "fromEvent(document, 'click')",
    inputs: [],
    apply: function (inputs, scheduler) {
      let t = 30;
      return from(["ev", "ev"]).pipe(
        delayWhen((ev) => timer((t += 20), scheduler))
      );
    }
  },

  fromEventPattern: {
    label: "fromEventPattern(addHandler, removeHandler)",
    inputs: [],
    apply: function (inputs, scheduler) {
      let t = 30;
      return from(["ev", "ev"]).pipe(
        delayWhen((ev) => timer((t += 20), scheduler))
      );
    }
  },

  generate: {
    label:
      "generate({initialState: 0,condition: (x) => x < 3,iterate: (x) => x + 1,resultSelector: (x) => x})",
    inputs: [],
    apply: function (inputs, scheduler) {
      return generate({
        initialState: 0,
        condition: (x) => x < 3,
        iterate: (x) => x + 1,
        resultSelector: (x) => x
      }).pipe(delayWhen((x) => timer(x * 10, scheduler)));
    }
  },

  iif: {
    label: "iif(() => boolean, trueObservable, falseObservable)",
    inputs: [],
    apply: function (inputs, scheduler) {
      return iif(() => true, of("true"), of("false"));
    }
  },

  interval: {
    label: "interval(10, scheduler)",
    inputs: [],
    apply: function (inputs, scheduler) {
      return interval(10, scheduler);
    }
  },

  of: {
    label: "of(1,2,3)",
    inputs: [],
    apply: function (inputs, scheduler) {
      return of(1, 2, 3).pipe(delayWhen((x) => timer(x * 10, scheduler)));
    }
  },

  range: {
    label: "range(1, 10)",
    inputs: [],
    apply: function (inputs, scheduler) {
      return range(1, 10).pipe(delayWhen((x) => timer(x * 10, scheduler)));
    }
  },

  timer: {
    label: "timer(start: 30, interval: 10)",
    inputs: [],
    apply: function (inputs, scheduler) {
      return timer(30, 10, scheduler);
    }
  }
};
